export default __webpack_public_path__ + "static/media/chico_escritorio_ordenador.240b8b17.svg";